module.exports = __webpack_public_path__ + "static/react-0394f0d287e1d42586491b54ad34e20d.png";